
export interface TableColumn {
  keyword: string;
  title?: string;
  type?: TableColumnType;
  condition?: any;
  dateFormat?: string;
  sortable?: boolean;
  isActionColumn?: boolean;
  columnClass?: string[];
  theadCellClass?: string | string[];
  tbodyCellClass?: string | string[];
}

export enum TableColumnType {
  index = 'index',

  string = 'string',

  html = 'html',

  number = 'number',

  textarea = 'textarea',

  radiobutton = 'radiobutton',

  select = 'select',

  date = 'date',

  dateRange = 'dateRange',

  button = 'button',

  inputCheckbox = 'inputCheckbox',

  inputAttachment = 'inputAttachment',

  inputText = 'inputText',

  inputNumber = 'inputNumber',

}
